export interface IAisAnticoll {  
  module_status: 'OFF' | 'NO_RISK' | 'RISK' | 'NO_DATA'
}

export const getDefaultAisAnticoll = (): IAisAnticoll => {
  return {
    module_status: 'OFF'
  }
} 
  